import React from 'react';
export function Footer() {
  return <footer className="bg-ev-deep px-4 py-4 text-center text-ev-steel" data-id="element-63" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-64" data-mp="3ggaqtvj9sd5g">
        <p className="text-[11px] font-semibold leading-snug sm:text-xs" data-id="element-65" data-mp="3ghc486nrdbqc">
          © 2026 EV &amp; HYBRID DIAGNOSTIC PRO™ — All Rights Reserved.
        </p>
        <p className="mt-1 text-[11px] font-medium leading-snug text-ev-steel/80 sm:text-xs" data-id="element-66" data-mp="36qhg0wqyc229">
          EV &amp; HYBRID DIAGNOSTIC PRO™ is a professional diagnostic reference and
          troubleshooting resource. It does not replace required high-voltage training, manufacturer
          instructions, workplace safety procedures or qualified professional judgment.
        </p>
        <p className="mt-1 text-[11px] font-semibold leading-snug sm:text-xs" data-id="element-67" data-mp="3qcx8yck7oq3s">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-ev-green underline" data-id="element-68" data-mp="2a19sxkaopkw8">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}